/**
 * Upgrade no cart drawer.
 *
 * IMPORTANTE — por que a delegação no document:
 * O drawer do Dawn se atualiza via `innerHTML = ...` (renderContents). Duas
 * consequências que já causaram bug aqui:
 *   1. <script> inserido por innerHTML NÃO executa. Por isso este arquivo é
 *      carregado no layout/theme.liquid, e não dentro do snippet - senão ele
 *      só rodava quando o bloco de upgrade já existia no HTML inicial da
 *      página, e não quando o bloco aparecia depois de uma mudança no carrinho
 *      (clicar no botão não fazia nada até recarregar).
 *   2. Um listener preso ao elemento morre junto com o nó antigo a cada
 *      re-render. Por isso escutamos no document e filtramos pelo seletor:
 *      funciona pra qualquer botão de upgrade, inclusive os que aparecerem
 *      depois.
 */
(function () {
  if (window.__cartUpgradeBound) return;
  window.__cartUpgradeBound = true;

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('.cu-btn[data-action="do-upgrade"]');
    if (!btn) return;

    const root = btn.closest('cart-upgrade');
    if (!root) return;

    doUpgrade(root, btn);
  });

  /**
   * Troca o produto original pelo upgrade numa única requisição.
   *
   * O endpoint /cart/update.js aceita, no objeto `updates`:
   *   - a CHAVE da linha (item.key) -> zeramos ela pra remover o original.
   *     Usamos a chave e não o variant_id porque o carrinho pode ter várias
   *     linhas com o mesmo variant_id (propriedades/descontos diferentes),
   *     e a chave garante que mexemos só na linha certa.
   *   - um variant_id que ainda não está no carrinho -> ele é ADICIONADO.
   *
   * Fazer os dois na mesma chamada evita um estado intermediário em que o
   * cliente ficaria sem o item caso a segunda requisição falhasse.
   */
  async function doUpgrade(root, btn) {
    if (btn.disabled) return;

    const lineKey = root.dataset.lineKey;
    const upgradeVariantId = root.dataset.upgradeVariantId;
    const quantity = parseInt(root.dataset.quantity, 10) || 1;

    if (!lineKey || !upgradeVariantId) return;

    const btnText = btn.querySelector('.cu-btn-text');
    const btnLoad = btn.querySelector('.cu-btn-loading');

    btn.disabled = true;
    if (btnText) btnText.style.display = 'none';
    if (btnLoad) btnLoad.style.display = 'flex';

    const updates = {};
    updates[lineKey] = 0;
    updates[upgradeVariantId] = quantity;

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });

      if (!res.ok) throw new Error('Erro ao fazer upgrade');
      let parsedState = await res.json();

      /**
       * Marca a linha nova com a origem, pra você conseguir ver no pedido
       * que aquele item entrou por causa do upgrade (Admin > Pedidos, no
       * detalhe da linha). O nome começa com "_", então o Shopify esconde
       * do cliente no carrinho, checkout e e-mails.
       *
       * Vai numa requisição separada porque /cart/update.js só aceita
       * quantidades - propriedades de linha só dá pra definir via
       * /cart/change.js. Fica por último de propósito: se esta chamada
       * falhar, a troca (o que interessa pro cliente) já está feita e só
       * perdemos a etiqueta.
       */
      try {
        const newLine = (parsedState.items || []).find(
          (item) => String(item.variant_id) === String(upgradeVariantId)
        );

        if (newLine && newLine.key) {
          const tagRes = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: newLine.key,
              quantity: newLine.quantity,
              properties: { _added_via: 'cart-upgrade' },
              sections: 'cart-drawer,cart-icon-bubble',
            }),
          });

          if (tagRes.ok) parsedState = await tagRes.json();
        }
      } catch (tagError) {
        /* etiqueta é best-effort: a troca já foi concluída */
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    } catch (error) {
      if (btnLoad) btnLoad.style.display = 'none';
      if (btnText) btnText.style.display = '';
      btn.disabled = false;
    }
  }
})();